import axios from 'axios';
import config from '../common/config';

export default {
  sendMessage(token, rideId, message, history) {
    return axios.post(
      `${config.config.ROOT_URL}/ai_chat_api/${rideId}`,
      { message, history },
      { headers: { Authorization: `Bearer ${token}` } },
    );
  },

  getJobStatus(token, jobId) {
    return axios.get(`${config.config.ROOT_URL}/job_status/${jobId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

addSingleSuggestedArea(token, rideId, area) {
    return axios.post(
      `${config.config.ROOT_URL}/add_single_suggested_area_api/${rideId}`,
      { area },
      { headers: { Authorization: `Bearer ${token}` } },
    );
  },

deleteSuggestedAccommodation(token, accommodationId) {
    return axios.delete(
      `${config.config.ROOT_URL}/delete_suggested_accommodation_api/${accommodationId}`,
      { headers: { Authorization: `Bearer ${token}` } },
    );
  },

  updateSuggestedArea(token, accommodationId, area) {
    return axios.put(
      `${config.config.ROOT_URL}/update_suggested_area_api/${accommodationId}`,
      { area },
      { headers: { Authorization: `Bearer ${token}` } },
    );
  },
};
